<script lang="ts" setup>
import type { ICellRendererParams } from 'ag-grid-community';
import type { ComputedRef, PropType} from 'vue';
import { computed } from 'vue';
import MappingWorkTags from '@/components/mappings/analyze/MappingWorkTags.vue';
import type MappingEmploymentTag from '@sysarb/sysarb-api/models/entities/MappingEmploymentTag';
import type { TagState } from '@sysarb/sysarb-api/models/entities/WorkTag';
import type WorkTag from '@sysarb/sysarb-api/models/entities/WorkTag';
import type AsyncData from '@sysarb/sysarb-api/models/common/AsyncData';
import type MappingEmployment from '@sysarb/sysarb-api/models/entities/MappingEmployment';

export type WorkTagComponentParams = {
    selectedEmploymentTags: (params: ICellRendererParams) => MappingEmploymentTag[];
    workTags: (params: ICellRendererParams) => AsyncData<WorkTag[]>;
    readonly: (params: ICellRendererParams) => boolean;
    toggleTag: (data: WorkTag, tagState: TagState | null) => void | undefined;
};

type ExtendedParams = ICellRendererParams<MappingEmployment, void> & WorkTagComponentParams;

const props = defineProps({
    params: {
        type: Object as PropType<ExtendedParams>,
        required: true
    }
});

const selectedEmploymentTags: ComputedRef<MappingEmploymentTag[]> = computed(() => (typeof props.params.selectedEmploymentTags === 'function' ? props.params.selectedEmploymentTags(props.params) : props.params.selectedEmploymentTags));
const workTags: ComputedRef<AsyncData<WorkTag[]>> = computed(() => (typeof props.params.workTags === 'function' ? props.params.workTags(props.params) : props.params.workTags)) as ComputedRef<AsyncData<WorkTag[]>>;
const readonly = computed(() => (typeof props.params.readonly === 'function' ? props.params.readonly(props.params) : props.params.readonly));

function toggleTag(data: WorkTag, tagState: TagState | null): void {
    if (typeof props.params.toggleTag === 'function') {
        props.params.toggleTag(data, tagState);
    }
}
</script>

<template>
    <MappingWorkTags
        class="width-100"
        :selected-work-tags="selectedEmploymentTags"
        :async-work-tags="workTags"
        :readonly="readonly"
        @toggle-tag="toggleTag"
    />
</template>
